<div fxFlex="0 0 auto" fxLayout="row" fxLayoutGap="200px">
  <div class="add-staff-marketing-wrapper" fxFlex="424px" fxLayout="column" fxLayoutGap="20px">
    <div class="main-header-wrapper" fxFlex="40px" fxLayout="row" fxLayoutGap="10px">
      <img src="../../../../assets/images/account_logo.png" height="40" width="40"/>
    </div>

    <div fxFlex fxLayout="row" class="find-warning">
      <label class="header">We’ve added your facility. Let’s now add your staff.</label>
    </div>

    <div fxFlex fxLayout="row" fxLayoutGap="100px">
      <label class="info">Check out the video below for tips on how to add your staff</label>
    </div>

    <div fxFlex="auto"fxLayout="column">
      <video width="506" height="285" controls>
        <source src="https://s3.amazonaws.com/intelycare.net/assets/add-staff-2.mp4" type="video/mp4">
      </video>
    </div>
  </div>
</div>
